import { ERROR, SUCCESS, CLEAN_ALERT } from '../variables'

export default {
	state: {
		alerts: []
	},
	getters: {
		alerts: state => state.alerts
	},
	actions: {
		[ERROR]: ({ commit, dispatch }, error) => {
			if (typeof error === 'string') {
				commit(ERROR, error)
			} else if (!!error.response && !!error.response.data && !!error.response.data.message) {
				commit(ERROR, error.response.data.message)
			} else {
				commit(ERROR, error.message)
			}
			setTimeout(function () {
				commit(CLEAN_ALERT, 0)
			}, 5000)
		},
		[SUCCESS]: ({ commit, dispatch }, message) => {
			commit(SUCCESS, message)
			setTimeout(function () {
				commit(CLEAN_ALERT, 0)
			}, 5000)
		},
		[CLEAN_ALERT]: ({ commit, dispatch }, i) => {
			commit(CLEAN_ALERT, i)
		}
	},

	mutations: {
		[ERROR]: (state, message) => {
			state.alerts.push({
				message: message,
				success: false
			})
		},
		[SUCCESS]: (state, message) => {
			state.alerts.push({
				message: message,
				success: true
			})
		},
		[CLEAN_ALERT]: (state, i) => {
			state.alerts.splice(i, 1)
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/alert.js